import { IMarcaProduto } from "@/interfaces/IMarcaProduto";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "..";

interface MarcaProdutoState {
  items: IMarcaProduto[];
  synced: boolean;
}

const initialState: MarcaProdutoState = {
  items: [],
  synced: false,
};

const marcaProdutoSlice = createSlice({
  name: "MARCA_PRODUTO",
  initialState,
  reducers: {
    sync: (state, action: PayloadAction<{ items: IMarcaProduto[] }>) => {
      state.items = action.payload.items;
      state.synced = true;
    },
  },
});

export default marcaProdutoSlice.reducer;

export const getMarcaProdutoSynced = (state: RootState) =>
  state.marcaProduto.items;
